import { CustomDataGrid } from '../../components/StripedDataGrid';
import { GridColDef } from '@mui/x-data-grid';
import { useAppSelector } from '../../hooks';
import axios from 'axios';
import { ITray } from '../../interfaces/ITray';
import { useEffect, useState } from 'react';
import { IBench } from '../../interfaces/IBench';
import { IZone } from '../../interfaces/IZone';
import { IBay } from '../../interfaces/IBay';
import { IGreenhouse } from '../../interfaces/IGreenhouse';
import { compose } from '@mui/system';

const columnSelection: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 130 },
    { field: 'size', headerName: 'Size', width: 130 },
    { field: 'species', headerName: 'Species', width: 130 },
    { field: 'variety', headerName: 'Variety', width: 130, },
    { field: 'color', headerName: 'Color', width: 120, },
    { field: 'barcode', headerName: 'Barcode', width: 120, },
  ];



export default function DailyTasksSelection() {
    const [trayRows, setTrayRows] = useState<ITray[]>([]);
    const fetchedSelection = useAppSelector((state) => state.selection);
    useEffect(() => {
        console.log("FETCHED SELECTION", fetchedSelection);
        axios.get<ITray[]>(`${process.env.REACT_APP_ENDPOINT}/api/Trays`).then(x => {
            let trays = x.data;
            let filteredTrays = trays.filter(x => fetchedSelection.selection.includes(x.id));
            console.log("FILTERED TRAYS");
            setTrayRows(filteredTrays);
        })
    }, [])

    useEffect(() => {
        axios.get<ITray[]>(`${process.env.REACT_APP_ENDPOINT}/api/Trays`).then(x => {
            let trays = x.data;
            let filteredTrays = trays.filter(x => fetchedSelection.selection.includes(x.id));
            console.log("FILTERED TRAYS");
            setTrayRows(filteredTrays);
        })
    }, [fetchedSelection])
    return (
        <CustomDataGrid
            rows={trayRows}
            columns={columnSelection}
            pageSize={20}
            rowsPerPageOptions={[20]}
            checkboxSelection
            sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
            getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
            }
        />
    )
}